import { useEffect, useState } from "react";
import { Mail } from "lucide-react";
import api from "../../lib/api";

const COLS = [
  ["emails_sent", "Sent"], ["leads_contacted", "Contacted"], ["replies", "Replies"], ["reply_rate", "Reply %"],
  ["positive_replies", "Positive"], ["positive_rate", "Positive %"], ["unsubscribes", "Unsubs"],
];

const Cells = ({ r }) => COLS.map(([k]) => (
  <td key={k} className="p-3 text-right font-mono text-slate-200">{k.endsWith("rate") ? `${r[k]}%` : r[k]}</td>
));

export default function OutreachReport({ range, onData }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    const params = {};
    if (range.start) params.start = range.start;
    if (range.end) params.end = range.end;
    api.get("/reports/outreach", { params })
      .then(({ data }) => { setData(data); onData?.(data); })
      .catch(() => { setData(null); onData?.(null); });
  }, [range, onData]);

  if (!data) return null;
  return (
    <div data-testid="report-outreach" className="rounded-xl border border-slate-800 bg-[#131C31] p-5 mb-6">
      <h3 className="font-display font-bold text-base mb-1 inline-flex items-center gap-2"><Mail className="w-5 h-5 text-amber-400" /> Outreach Results</h3>
      <p className="text-xs text-slate-400 mb-4">Credited to the admin who approved each email. Team-wide (not affected by the salesperson filter). Rates are out of leads contacted in the period.</p>
      <div className="overflow-x-auto">
        <table className="w-full text-sm min-w-[720px]">
          <thead className="text-xs uppercase tracking-wider text-slate-500 border-b border-slate-800">
            <tr><th className="p-3 text-left">Approved by</th>{COLS.map(([k, l]) => <th key={k} className="p-3 text-right">{l}</th>)}</tr>
          </thead>
          <tbody>
            {data.rows.length === 0 ? (
              <tr><td data-testid="report-outreach-empty" colSpan={8} className="p-6 text-center text-slate-500">No outreach emails sent in this period.</td></tr>
            ) : data.rows.map((r) => (
              <tr key={r.approver} data-testid={`report-outreach-row-${r.approver}`} className="border-b border-slate-800/60">
                <td className="p-3 font-semibold text-white">{r.approver}</td><Cells r={r} />
              </tr>
            ))}
            {data.rows.length > 0 && (
              <tr data-testid="report-outreach-totals" className="bg-amber-500/5">
                <td className="p-3 font-bold text-amber-400">Total</td><Cells r={data.totals} />
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
